<!-- Built with Common Launchpad 2.0.3 -->

<template>
    <div class="office-search-results-item" :class="{active: selectedLocation === item.Guid}" @click="handleSelectedBehavior(item.Guid)">
        <div class="item-number">{{index}}</div>
        <a :href="item.Url" class="item-title">Interim HealthCare of {{item.DisplayName}}</a>
        <p class="item-subtitle">{{services}}</p>
        <div class="item-content-container">
            <div class="item-content-container-col">
                <p class="item-distance">{{item.Distance}} Miles Away</p>
                <p class="item-address">
                    {{item.Address.Address1}},
                    {{item.Address.Address2}}<br />
                    {{item.Address.City}}, {{item.Address.State.Abbreviation}} {{item.Address.Zipcode}}
                </p>
                <p class="item-hours" v-if="!item.OpensAllDay">
                    <b>{{isClosed ? "Closed Now" : "Open Now"}}</b><br class="d-none d-lg-block" />
                    {{isClosed ? nextDateTime  : `Closes ${item.Hours[currentDay].From}`}}
                </p>
                <p class="item-hours" v-if="item.OpensAllDay">
                    <b>Open 24 hours</b>
                </p>
            </div>
            <div class="item-content-container-col">
                <a :href="`tel:${item.Phone}`" class="cta cta-primary cta-phone">{{item.Phone}}</a>
                <a :href="item.Url" class="cta cta-secondary">More Information</a>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['item', 'index'],
        data: function() {
            return {
                services: "",
                date: '',
                isClosed: false,
                currentDay: moment().format('dddd'),
                nextDateTime: ''
            }
        },
		components: {

		},
        computed: mapState({
            selectedLocation: state => state.listing.selectedLocation,
		}),
		mounted: function () {
            this.services = '';
            this.formatServices();
            this.handleDate();
		},
        methods: {
            ...mapMutations('listing', { setSelectedLocation: 'setSelectedLocation' }),

            formatServices() {
                if (this.item.HomeHealthcare) {
                    this.services += "Home Healthcare";
                }
                if (this.item.PersonalCare) {
                    this.concatDotSimbol();
                    this.services += "Personal Care";
                }
                if (this.item.HospiceAtHome) {
                    this.concatDotSimbol();
                    this.services += "Hospice";
                }

                if (this.item.MedicalStaffing)
                {
                    this.concatDotSimbol();
                    this.services += "Medical Staffing";
                }
            },
            concatDotSimbol() {
                if (this.services.length > 0) {
                    this.services += " • ";
                }
            },
            handleDate() {
                if (this.item.OpensAllDay) return;

                let openHours = moment(this.item.Hours[this.currentDay].From, 'hh:mm:ss a');
                let closingHours = moment(this.item.Hours[this.currentDay].To, 'hh:mm:ss a');

                if (moment().isBetween(openHours, closingHours))
                {
                    this.isClosed = false;
                } else {
                    this.isClosed = true;
                    let nextDate = false;
                    let index = 1;
                    while(!nextDate) {
                        let day = moment().add(index, 'day').format('dddd');
                        let nextDayHours = this.item.Hours[day].From;
                        if (nextDayHours.length != 0) {
                            nextDate = true;
                            this.nextDateTime = `Opens ${this.item.Hours[day].From} ${day}`;
                        }
                        index++;
                    }
                }
            },
            handleSelectedBehavior(guid) {
                this.setSelectedLocation(guid);
                if (window.innerWidth < 970)  {
                    document.getElementById('map').scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            }
        },
        filters: {
        }
    }
</script>